import MainLoadingDigidom from './MainLoadingDigidom';

export default MainLoadingDigidom;
